import {connect} from "react-redux";
import Phone from "./../component/Phone";
import {changePhoneNumber} from "../actions";
import {getFilledPhoneNumber, issetErrorForField, getErrorForField} from "../reducers";

const mapStateToProps = state => {
    return {
        valueNumber: getFilledPhoneNumber(state),
        isError: issetErrorForField('phone1', state) || issetErrorForField('phone1_number', state),
        errorMessage: getErrorForField('phone1', state) || getErrorForField('phone1_number', state),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeNumber: (value) => {
            dispatch(changePhoneNumber(value))
        },
    }
}

const PhoneContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Phone)

export default PhoneContainer